import { NgModule } from '@angular/core';

import {
  AbsoluteValuePipe,
  ActiveBatchPipe,
  ActiveOrderPipe,
  ActiveShipmentPipe,
  BatchReprintPipe,
  DateFormatPipe,
  DaysUntilDuePipe,
  DisplayNamePipe,
  DpoHoldReasonPipe,
  HoldReasonPipe,
  IdFilterPipe,
  ItemStatusPipe,
  JobHoldReasonPipe,
  JobPrintStationPipe,
  JobMachinePipe,
  KeysPipe,
  LengthPipe,
  LocationFormatPipe,
  OpenBatchesPipe,
  OrderByPipe,
  PackageDisplayPipe,
  PrefixFilterPipe,
  ReplacePipe,
  SortPipe,
  SortRecordsPipe,
  TimeSinceNowPipe,
  TruncatePipe,
  TypeFilterPipe,
  NoDieCheck,
  CalcQtyPipe,
  countBatchJobsPipe,
  HorizonFilterPipe
} from './pipes';

@NgModule({
  declarations: [
    AbsoluteValuePipe,
    ActiveBatchPipe,
    ActiveOrderPipe,
    ActiveShipmentPipe,
    BatchReprintPipe,
    DateFormatPipe,
    DaysUntilDuePipe,
    DisplayNamePipe,
    DpoHoldReasonPipe,
    HoldReasonPipe,
    IdFilterPipe,
    ItemStatusPipe,
    JobHoldReasonPipe,
    JobPrintStationPipe,
    JobMachinePipe,
    KeysPipe,
    LengthPipe,
    LocationFormatPipe,
    OpenBatchesPipe,
    OrderByPipe,
    PackageDisplayPipe,
    PrefixFilterPipe,
    ReplacePipe,
    SortPipe,
    SortRecordsPipe,
    TimeSinceNowPipe,
    TruncatePipe,
    TypeFilterPipe,
    NoDieCheck,
    CalcQtyPipe,
    countBatchJobsPipe,
    HorizonFilterPipe
  ],
  exports: [
    AbsoluteValuePipe,
    ActiveBatchPipe,
    ActiveOrderPipe,
    ActiveShipmentPipe,
    BatchReprintPipe,
    DateFormatPipe,
    DaysUntilDuePipe,
    DisplayNamePipe,
    DpoHoldReasonPipe,
    HoldReasonPipe,
    IdFilterPipe,
    ItemStatusPipe,
    JobHoldReasonPipe,
    JobPrintStationPipe,
    JobMachinePipe,
    KeysPipe,
    LengthPipe,
    LocationFormatPipe,
    OpenBatchesPipe,
    OrderByPipe,
    PackageDisplayPipe,
    PrefixFilterPipe,
    ReplacePipe,
    SortPipe,
    SortRecordsPipe,
    TimeSinceNowPipe,
    TruncatePipe,
    TypeFilterPipe,
    NoDieCheck,
    CalcQtyPipe,
    countBatchJobsPipe,
    HorizonFilterPipe
  ]
})
export class PipesModule {}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes.module.ts